var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view',{staticClass:"pub-content"}),_c('air-footer',{staticClass:"w-100 fullpage"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }